<template>
  <div class="px-page mb-8">
    <div class="flex items-center justify-between">
      <h2 class="font-semibold text-xl leading-tight">
        Manage | Edit User | {{ user.name }}
      </h2>
      <div class="flex items-center justify-end space-x-3">
        <a v-bind:href="$route('manage.users.index')" class="btn btn-secondary">Cancel</a>
        <button v-on:click="form.post($route('manage.users.update', user.id))" v-bind:disabled="form.processing" class="btn btn-primary" type="button">Save</button>
      </div>
    </div>
  </div>

  <div class="card mb-8">
    <div class="card-body">
      <div class="space-y-6 sm:space-y-5">
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
          <label for="name" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Name </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <input v-model="form.name" type="text" id="name" class="rounded-md shadow-sm border-gray-300 focus:outline-none focus:border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 disabled:opacity-25 transition ease-in-out duration-150 max-w-lg block w-full sm:max-w-xs sm:text-sm" />
            <small v-if="errors.name" class="text-sm text-red-500">{{ errors.name }}</small>
          </div>
        </div>

        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
          <label for="email" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Email </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <input v-model="form.email" type="text" id="email" class="rounded-md shadow-sm border-gray-300 focus:outline-none focus:border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 disabled:opacity-25 transition ease-in-out duration-150 max-w-lg block w-full sm:max-w-xs sm:text-sm" />
            <small v-if="errors.email" class="text-sm text-red-500">{{ errors.email }}</small>
          </div>
        </div>

        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
          <label for="email" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Password </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <input v-model="form.password" type="text" id="email" class="rounded-md shadow-sm border-gray-300 focus:outline-none focus:border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 disabled:opacity-25 transition ease-in-out duration-150 max-w-lg block w-full sm:max-w-xs sm:text-sm" />
            <small v-if="errors.password" class="text-sm text-red-500">{{ errors.password }}</small>
          </div>
        </div>

        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
          <label for="title" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Title </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <input v-model="form.title" type="text" id="title" class="rounded-md shadow-sm border-gray-300 focus:outline-none focus:border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 disabled:opacity-25 transition ease-in-out duration-150 max-w-lg block w-full sm:max-w-xs sm:text-sm" />
            <small v-if="errors.title" class="text-sm text-red-500">{{ errors.title }}</small>
          </div>
        </div>

        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
          <label for="role" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Role </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <select v-model="form.role" id="role" class="rounded-md shadow-sm border-gray-300 focus:outline-none focus:border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 disabled:opacity-25 transition ease-in-out duration-150 max-w-lg block w-full sm:max-w-xs sm:text-sm" >
              <option disabled>Select a Role</option>
              <template v-for="role in roles">
                <option v-bind:value="role.slug" v-bind:selected="role.id === form.role">{{ role.name }}</option>
              </template>
            </select>
            <small v-if="errors.role" class="text-sm text-red-500">{{ errors.role }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="px-page mb-8">
    <h2 class="font-semibold text-xl leading-tight">
      Permissions
    </h2>
  </div>

  <div class="card">
    <div class="card-body">
      <div class="space-y-6 sm:space-y-5">
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
          <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Audits </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <Switch v-model="form.permissions.audits" v-bind:class="[form.permissions.audits ? 'bg-primary-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2']">
              <span class="sr-only">Use setting</span>
              <span aria-hidden="true" v-bind:class="[form.permissions.audits ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
            </Switch>
          </div>
        </div>

        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
          <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Customs </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <Switch v-model="form.permissions.customs" v-bind:class="[form.permissions.customs ? 'bg-primary-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2']">
              <span class="sr-only">Use setting</span>
              <span aria-hidden="true" v-bind:class="[form.permissions.customs ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
            </Switch>
          </div>
        </div>

        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
          <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Quality Assurance </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <Switch v-model="form.permissions['quality-assurance']" v-bind:class="[form.permissions['quality-assurance'] ? 'bg-primary-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2']">
              <span class="sr-only">Use setting</span>
              <span aria-hidden="true" v-bind:class="[form.permissions['quality-assurance'] ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
            </Switch>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { Switch } from '@headlessui/vue';
  import { useForm } from "@inertiajs/vue3";

  const { errors, user, roles } = defineProps({
    errors: Object,
    user: Object,
    roles: Array,
  });

  const form = useForm({
    name: user.name,
    email: user.email,
    password: null,
    title: user.title,
    role: user.role_id,
    permissions: {
      audits: user.permissions.audits,
      customs: user.permissions.customs,
      'quality-assurance': user.permissions['quality-assurance'],
    }
  })
</script>
